import type { ReactNode } from "react";
import notFoundImage from "../images/404-icon.png";

import PageLayout from "./layout";

export default function NotFound(): ReactNode {
  return (
    <PageLayout title="CloudQuote API Platform">
      <div className="not-found">
        <img src={notFoundImage}/>
        <div className="code">
          <strong>Error:</strong> 404
        </div>
        <div className="info">The page you requested cannot be found</div>
      </div>
    </PageLayout>
  );
}
